import React, { Component } from 'react';
import { connect } from 'react-redux';
import firebase from 'firebase';
import 'firebase/functions';
import { TextField, Typography, Paper, Button, Chip, Avatar, Icon, CircularProgress } from '@material-ui/core';
import { PageHeader, Dropdown } from '../../components';
import './CreateTeam.scss';

class CreateTeam extends Component {
  state = {
    imageSelected: false,
    image: '',
    teamLeader: '',
    teamMembers: [],
    teamName: '',
    isCreating: false
  };

  colors = [
    '#593C8F',
    '#5FB49C',
    '#ff753c',
    '#0051a3',
    '#EF6F6C',
    '#fed13c'
  ];

  // handleImage(e) {
  //   this.setState({image: e.target.files[0], imageSelected: true});
  //   const uploadTask = this.storageRef.child('images/0').put(this.state.image);
  //   uploadTask.on('state_changed', (snapshot) => {
  //     console.log(snapshot);
  //     console.log(snapshot.val());
  //   })
  // }

  addUserToTeam(uid) {
    let teamMembers = this.state.teamMembers;
    teamMembers.push(uid);
    this.setState({ teamMembers });
  }

  removeFromTeam(uid) {
    let teamMembers = this.state.teamMembers;
    teamMembers.splice(teamMembers.indexOf(uid), 1);
    this.setState({ teamMembers });
  }

  selectTeamLeader(uid) {
    this.setState({ teamLeader: uid });
    this.removeFromTeam(uid);
  }

  createTeam() {
    const addTeam = firebase.functions().httpsCallable('addTeam');
    this.setState({ isCreating: true });
    addTeam(this.state)
      .then(() => {
        this.setState({ isCreating: false });
        this.props.closeModal();
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isCreating: false });
        this.props.closeModal();
      });
  }

  get createValid() {
    if (!this.state) return false;
    return this.state.teamName !== '' && this.state.teamMembers.length > 0 && this.state.teamLeader !== '';
  }

  renderCurrentTeamMembers() {
    if (this.state.teamMembers.length === 0) return null;
    let userIds = this.props.users.map((user) => user.uid);
    let users = this.state.teamMembers.map((member) => this.props.users[userIds.indexOf(member)]);
    return (
      users.map((user) => {
        let className = "chip color" + (users.indexOf(user) % this.colors.length).toString();
        return (
          <Chip
            avatar={<Avatar alt="profilepic" src={user.photoURL} />}
            label={user.displayName}
            key={user.uid}
            className={className}
            onDelete={this.removeFromTeam.bind(this, user.uid)}
          />
        );
      })
    );
  }

  render() {
    const { users } = this.props;
    let usersAvailable = [];
    users.forEach((user) => {
      if (this.state.teamMembers.indexOf(user.uid) === -1
      && user.uid !== this.state.teamLeader) usersAvailable.push(user);
    });

    if (this.state.isCreating) {
      return (
        <div className="createModalStyle">
          <Paper className="createTeamBackground">
            <CircularProgress className="spinner"/>
          </Paper>
        </div>
      );
    }

    return (
      <div className="createModalStyle">
        <Paper className="createTeamBackground">
          <Icon onClick={this.props.closeModal.bind(this)} className="exitModal">cancel</Icon>
          <PageHeader color="black">Create Team</PageHeader>

          {/* TODO team image upload */}
          {/* <div className="image">
            <Typography >Enter Team Picture</Typography>
            <Input disableUnderline onChange={this.handleImage.bind(this)} className="fileUpload" type='file' />
            {this.state.imageSelected &&
            <Avatar src={this.state.image}></Avatar>}
          </div> */}

          <div className="teamName">
            <Typography>Enter Team Name</Typography>
            <TextField
              className="teamNameInput"
              value={this.state.teamName}
              onChange={(val) => this.setState({ teamName: val.target.value })}
            />
          </div>
          <div className="leaderDropdownHolder">
            <Dropdown
              dropdownNum={'0'}
              items={users}
              display="displayName"
              labelText="Choose a Team Leader"
              clearSelection={() => this.setState({ teamLeader: '' })}
              selectItem={(uid) => this.selectTeamLeader(uid)}
            />
          </div>

          <div className="membersSection">
            {this.state.teamMembers.length ? <Typography>Members of {this.state.teamName ? this.state.teamName : 'Team'}</Typography> : null}
            <div className="members">
              {this.state.teamMembers.length ? this.renderCurrentTeamMembers() : null}
            </div>
          </div>

          <div className="addUsers">
            <Dropdown
              dropdownNum={'1'}
              items={usersAvailable}
              display="displayName"
              labelText="Add Users to this Team"
              clearTextAfterSelect={true}
              selectItem={(uid) => this.addUserToTeam(uid)}
              clearSelection={()=>{}}
            />
          </div>

          <Button
            className="createTeamButton"
            variant="contained"
            color="primary"
            disabled={!this.createValid}
            onClick={this.createTeam.bind(this)}
          >
            Create Team
          </Button>

        </Paper>
      </div>
    );
  }
}

const mapStateToProps = ({ recognition }) => {
  const { users, usersLoading } = recognition;
  return { users, usersLoading };
};

export default connect(mapStateToProps)(CreateTeam);


// WEBPACK FOOTER //
// ./src/screens/teams/CreateTeam.js